import React, {useCallback} from 'react';
import {DeleteIcon} from "../icons/icons/DeleteIcon";
import './entities-list-row.scss';
import {IconButton} from "../buttons/IconButton/IconButton";
import LinkWrapper from "../LinkWrapper/LinkWrapper";
import classNames from "classnames";
import {BaseEntityNameLess} from "../../api/entities/BaseEntity";
import DraggableItem from "../DraggableItem/DraggableItem";
import {ActionsProps} from "./EntitiesLoader/EntitiesLoader";


export type EntitiesListRowProps<T extends BaseEntityNameLess> = {
    entity: T;
    rowNumber?: number | null;
    deleteFn: ({entity}: { entity: T }) => void;
    form?: any; // fix type
    selected?: boolean;
    getUrlFunc?: (entity: T) => string;
    onRowClick: (entity: T) => Promise<void>;
    hasLink?: boolean;
    actions?: React.ComponentType<ActionsProps>[];
    loadDataFn?: () => Promise<void>;
    style?: any;
    attributes?: any;
    listeners?: any;
}

export const EntitiesListRow = React.memo(React.forwardRef(<T extends BaseEntityNameLess, >({
                                                                                                entity,
                                                                                                rowNumber,
                                                                                                deleteFn,
                                                                                                form: Form,
                                                                                                selected,
                                                                                                getUrlFunc,
                                                                                                onRowClick,
                                                                                                hasLink = true,
                                                                                                actions,
                                                                                                loadDataFn,
                                                                                                attributes,
                                                                                                listeners,
                                                                                                ...rest
                                                                                            }: EntitiesListRowProps<T>, ref: React.ForwardedRef<HTMLDivElement>) => {
    const classes = classNames(
        'entities-list-row',
        selected && 'entities-list-row_selected'
    );

    const onDeleteHandler = useCallback((event, entity: T) => {
        deleteFn?.({entity});
    }, [])

    return (
        <div
            className={classes}
            data-testid={`entitiesListRow_${entity.id}`}
            ref={ref}
            {...attributes}
            {...listeners}
            {...rest}
        >
            <div
                className={`entities-list-row__link-wrapper`}
                onClick={() => onRowClick(entity)}
            >
                <LinkWrapper
                    to={getUrlFunc?.(entity) ?? `./${entity.id}/`}
                    hasLink={hasLink}
                    className={`entities-list-row__link`}
                >
                    {
                        rowNumber !== null
                            ? <div className="entities-list-row__number">{rowNumber}</div>
                            : null
                    }
                    <div className={`entities-list-row__fields`}>
                        {Form ?
                            <Form entity={entity}/>
                            : entity.id
                        }
                    </div>
                </LinkWrapper>
            </div>
            <div className="entities-list-row__actions">
                {loadDataFn && actions?.map((Action, idx) => (
                        <Action
                            key={`${entity?.id}_action${idx}`}
                            id={entity?.id}
                            entityName={entity._entityName}
                            loadEntitiesFn={loadDataFn}
                        />
                    )
                )}
                <IconButton
                    className="entities-list-row__delete-btn"
                    icon={DeleteIcon}
                    width={20}
                    height={20}
                    onClick={(event) => onDeleteHandler(event, entity)}
                    borderless
                    testId="entitiesListRowDeleteBtn"
                />
            </div>
        </div>
    )
}))

export function EntitiesListItem<T extends BaseEntityNameLess>(props: EntitiesListRowProps<T> & {
    draggable?: boolean
}) {
    if (props.draggable) {
        return <DraggableItem<EntitiesListRowProps<T>> id={props.entity.id} Component={EntitiesListRow as any}
                                                       props={props}/>;
    }

    return (
        <EntitiesListRow {...props as any} />
    );
}